import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import FieldValue from 'components/atoms/text/FieldValue';
import { fetchBrand } from 'services/brands/duck';

const AssociatedBrandNameLink = (props) => {
    useEffect(() => {
        if (props.brandId) {
            props.fetchBrand({ brandId: props.brandId });
        }
    }, [props.brandId]);

    if (!props.brandId || !props.brand) {
        return null;
    }

    return (
        <Link to={`/admin/brands/${props.brandId}`} target="_blank" title="Go to brand">
            <FieldValue>{props.brand.name}</FieldValue>
        </Link>
    );
};

AssociatedBrandNameLink.propTypes = {
    brandId: PropTypes.number,
    brand: PropTypes.shape({
        name: PropTypes.string
    })
};

const mapStateToProps = state => ({
    brand: state.brands.brand,
});

export default connect(mapStateToProps, { fetchBrand })(AssociatedBrandNameLink);



// WEBPACK FOOTER //
// ./src/containers/forms/users/AssociatedBrandNameLink.js